import { type LayerKey, resolveTopologicalPath } from '@festina-life/api'
import type { Optional } from '@festina-life/core'
import { useCallback } from 'react'

import { useOpenConfigurationPath } from '../../components/configurationItemsTree/useOpenConfigurationPath'
import { useLayoutContext } from '../../context/layoutContext'
import { useMetaModelContext } from '../../context/metaModelContext'

export const useScrollToPath = () => {
  const { preferences, onChangeView } = useLayoutContext()
  const { layerTopology } = useMetaModelContext()
  const openConfigurationPath = useOpenConfigurationPath()

  return useCallback(
    (selectedLayer: LayerKey, packageName?: Optional<string>) => {
      const isConfigurationTreePanelOpen = preferences.leftSidebar === 'picker'

      if (!isConfigurationTreePanelOpen) {
        onChangeView({
          ...preferences,
          leftSidebar: 'picker',
        })
      }

      openConfigurationPath(selectedLayer, packageName)

      const allLayers = resolveTopologicalPath(selectedLayer, layerTopology)
      const layerPath = allLayers
        .map((itemLayer) => itemLayer.toString())
        .join('.')

      const [firstPackagePart, ...remainingPackageParts] =
        packageName?.split('.') ?? []
      const layerTenantId = selectedLayer.tenantId
      const itemPackageName =
        !layerTenantId &&
        selectedLayer.layerId?.localeCompare(firstPackagePart, undefined, {
          sensitivity: 'base',
        }) === 0
          ? remainingPackageParts.join('.')
          : packageName

      const elementId = itemPackageName
        ? `${layerPath}.${itemPackageName}`
        : layerPath

      const pathElement = document.querySelector(
        `[data-tree-scroll-path="${elementId}"]`,
      )

      if (pathElement) {
        pathElement.scrollIntoView({ block: 'center', behavior: 'instant' })
      }
    },
    [onChangeView, preferences, layerTopology, openConfigurationPath],
  )
}
